(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-router", "../StackRouter/matchPath", "../StackRouter/matchRoute", "../StackSwitch/useLocationKey"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-router"), require("../StackRouter/matchPath"), require("../StackRouter/matchRoute"), require("../StackSwitch/useLocationKey"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactRouter, global.matchPath, global.matchRoute, global.useLocationKey);
    global.usePremount = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactRouter, _matchPath, _matchRoute, _useLocationKey) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.usePremount = usePremount;

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function usePremount() {
    var _useContext = (0, _react.useContext)(_reactRouter.__RouterContext),
        views = _useContext.views,
        setViews = _useContext.setViews,
        locationHistory = _useContext.locationHistory,
        routes = _useContext.routes,
        routerIndex = _useContext.routerIndex;

    var routeMatch = (0, _reactRouter.useRouteMatch)();
    var refMounted = (0, _react.useRef)(false);
    var getPrevRoute = (0, _react.useCallback)(function () {
      var _currentLocation$stat;

      if (!routeMatch.active) {
        return;
      }

      var currentViewIndex = views.findIndex(function (view) {
        return view.key === routeMatch.key;
      });

      if (views[currentViewIndex + 1]) {
        return false;
      }

      var currentLocationIndex = locationHistory.findIndex(routeMatch.key);

      if (currentLocationIndex < 1) {
        return false;
      }

      var currentLocation = locationHistory.get(routeMatch.key);

      if ((_currentLocation$stat = currentLocation.state) !== null && _currentLocation$stat !== void 0 && _currentLocation$stat.__prevent) {
        return false;
      }

      var targetLocation = locationHistory.getPrev(routeMatch.key);

      if (!targetLocation) {
        return false;
      }

      var matchedRoute = (0, _matchRoute.matchRoute)(targetLocation.pathname, routes);

      if (!matchedRoute) {
        return false;
      }

      var matchedPath = (0, _matchPath.matchPath)(targetLocation.pathname, matchedRoute.props);
      var key = (0, _useLocationKey.getLocationKey)(targetLocation, routerIndex);
      var prevView = {
        key: key,
        route: matchedRoute,
        match: _objectSpread(_objectSpread({}, matchedPath), {}, {
          key: key
        })
      };
      return {
        location: targetLocation,
        view: prevView
      };
    }, [locationHistory, views, routes, routeMatch, routerIndex]);
    var premount = (0, _react.useCallback)(function () {
      if (refMounted.current) {
        return refMounted.current;
      }

      var prev = getPrevRoute();

      if (prev) {
        var existIndex = views.findIndex(function (view) {
          return view.key === prev.view.key;
        });

        if (existIndex < 0) {
          refMounted.current = prev;
          views.push(prev.view);
          setViews(_toConsumableArray(views));
        }
      }

      return prev;
    }, [views, getPrevRoute, setViews]);
    return premount;
  }
});